$(function () {
	<%- include('../source/general/callbacks/_common.js'); %>
	<%- include('../source/general/_change.js'); %>

	for(type of ["house", "company"]) {
		$("[data-action="+ type +"][data-target]").on("change", function () {
			let $target	=	$(this);
			let type	=	$target.closest("[data-action]").attr("data-action");

			if($("[data-group="+ type +"][data-name]:visible").length != 0) {

				$("[data-group="+ type +"][data-name]:visible").stop().fadeOut(function () {
					$(this).find("input, select, textarea").attr("disabled", true);
					$("[data-group="+ type +"][data-name="+ $target.attr("data-target") +"]").stop().fadeIn().find("input, select, textarea").removeAttr("disabled");
				});
			}
			else {
				$("[data-group="+ type +"][data-name="+ $target.attr("data-target") +"]").stop().fadeIn();
			}
		});

		$("[data-group="+ type +"][data-name]").hide();
		$("[data-action="+ type +"][data-target]:checked").trigger("change");
	}

	$("form.change input[name=email]").on("change input blur", function (e) {
		const $target	=	$(this);
		const $input	=	$("form.change input[name=pc]");

		if($input.attr("data-changed") != "1") {
			$input.val($target.val());
		}
	});

	$("form.change input[name=pc]").on("change input blur", function (e) {
		const $target	=	$(this);
		const $input	=	$("form.change input[name=email]");

		if($target.val() != $input.val()) {
			$target.attr("data-changed", "1")
		}
	});

	$("form.change").on("submit", function (e) {
		Callbacks.adjusts.headerHeight	=	$("#header").height() + 20;

		change.call(this, e)
	});
});
